import { z } from 'zod';

import {
  MAX_VERIFICATION_CODE_LENGTH,
  MIN_VERIFICATION_CODE_LENGTH,
} from '../verification-state/verification-state';

/**
 * `POST /auth/verification/{email,phone}/confirm`.
 *
 * A **string** of digits, never a number: a code may begin with `0`, and a
 * number would lose it before the api ever saw it. The bounds are the policy's
 * (`auth.verificationCode.length`), so a body outside them is refused as
 * malformed rather than spending an attempt on a code that cannot match.
 */
export const VerificationCodeConfirmSchema = z
  .object({
    code: z
      .string()
      .regex(new RegExp(`^\\d{${MIN_VERIFICATION_CODE_LENGTH},${MAX_VERIFICATION_CODE_LENGTH}}$`)),
  })
  .strict();

export type VerificationCodeConfirmRequest = z.infer<typeof VerificationCodeConfirmSchema>;
